<div  id="sidebar" class="sidebar">
  <img src="assets/images/logo.png" style="width: 75%; margin: 2px 0px;cursor: pointer;display: none;"
    class="navbar-toggle" id="close-arrow" (click)="toggleSidebar(true)" data-toggle="collapse" />
  <div class="header menu-hidden">
    <img src="assets/images/modo-seguro-logo.png" (click)="toggleSidebar(true)" />
  </div>
  <label class="greeting menu-hidden">Hola</label>

  <label class="greeting-username menu-hidden">{{nombreUsuario}}</label>
  <img src="assets/images/saesa-worker.png" class="saesa-worker menu-hidden" />

  <div class="header modulos menu-hidden">
    MÓDULOS&nbsp; <i class="fa fa-angle-double-down"></i>
  </div>

  <div *ngFor="let menu of menuUser">
    <div *ngIf="menu.codeMenu == 'inicio'">
      <a class="text-color" (click)="openComponentDashboard()">
        <div class="{{ menu.icon }}"></div>
        <span class="menu-item menu-hidden">{{ menu.nombreMenu }}</span>
      </a>
    </div>
    <div *ngIf="menu.codeMenu == 'planificacion'" class="treeview menu-open">
      <a class="text-color">
        <div class="{{ menu.icon }}"></div>
        <span class="menu-item menu-hidden" (click)="openComponentCapacitaciones()">{{ menu.nombreMenu }}</span>
        <span class="pull-right-container" style="margin-left: 10px;" (click)="isCollapsed ? false : true"
          data-toggle="collapse" data-target="#collapseExample" aria-expanded="false" aria-controls="collapseExample">
          <i class="menu-hidden fa fa-angle-up pull-up" *ngIf="isCollapsed"></i>
          <i class="menu-hidden fa fa-angle-down pull-down" *ngIf="!isCollapsed"></i>
        </span>
      </a>
      <ul class="treeview-menu" class="collapse menu-hidden" id="collapseExample">
        <div *ngFor="let subM of menu.subMenu">
          <div *ngIf="subM.codeMenu == 'generacionPlanBase'" class="submenu-item" (click)="clickSubMenu()">
            <label (click)="openModalCargaPlan(cargaPlanModal)" class="pointer">
              Generaci&oacute;n Plan Base
            </label>
          </div>
      
          <div *ngIf="subM.codeMenu == 'cargarPlanCapacitacion'"  class="submenu-item" (click)="clickSubMenu()">
            <label (click)="openComponentCargaMasiva()" class="pointer">
              Cargar Plan de Capacitaci&oacute;n
            </label>
          </div>
      
          <div *ngIf="subM.codeMenu == 'revisionPlanes'" class="submenu-item" (click)="clickSubMenu()">
            <label (click)="openAprobacion()" class="pointer">
              Revisi&oacute;n de Planes
            </label>
          </div>
      
          <div *ngIf="subM.codeMenu == 'anadirReforzamiento'" class="submenu-item" (click)="clickSubMenu()">
            <label (click)="openModal(capacitacionModal, 'reforzamiento')" class="pointer">
              Añadir reforzamiento
            </label>
          </div>
        </div>
      </ul> 
    </div>
    <div *ngIf="menu.codeMenu == 'mantenedores'">
      <a class="text-color" (click)="openMantenedores()">
        <div class="{{ menu.icon }}"></div>
        <span class="menu-item menu-hidden">{{ menu.nombreMenu }}</span>
      </a>
    </div>
  </div>
  

  <div>
    <img style="width: 80%; margin: 20px 0px;" src="assets/images/grupo-saesa-white-original.png">
  </div>
</div>
<ng-template #capacitacionModal let-modal>
  <app-capacitacion-modal [modal]="modal" [mode]="creationMode" [categoriesWithFocos]="categoriesWithFocos"
    [enfoques]="enfoques" [ejecutoresWithRelatores]="ejecutoresWithRelatores" [zonas]="zonas" (save)="onSave()"
    (accept)="onSaveAccept()">
  </app-capacitacion-modal>
</ng-template>

<ng-template #cargaPlanModal let-modal>
  <app-carga-plan-modal>

  </app-carga-plan-modal>
</ng-template>
